export default __webpack_public_path__ + "static/media/Traverxec_HTB.a7f14a86.md";